import { useQuery } from "@tanstack/react-query";
import { request } from "../../../common/api";
import { GET_LOW_MACHINERY_SELECT_OPTIONS } from "../../../common/query-keys";
import { SelectOption } from "../../../common/types/selectOption";
import { InputSelect } from "../../atoms/Inputs/InputSelect";
import { ChangeEvent } from "react";

interface LowMachinerySelectProps {
  machine?: string;
  value?: string;
  errored?: boolean;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}
export const LowMachinerySelect = ({
  machine,
  value,
  onChange,
  errored,
}: LowMachinerySelectProps) => {
  const { data: selectOptions } = useQuery<SelectOption[]>({
    queryKey: [GET_LOW_MACHINERY_SELECT_OPTIONS, machine],
    queryFn: async () => {
      if (!machine) {
        return [];
      }

      return await request<SelectOption[]>({
        method: "GET",
        url: `/equipment-info/low-machinery/select/options/${machine}`,
      });
    },
  });

  return (
    <InputSelect
      width={120}
      size="sm"
      placeholder="계통 선택"
      options={selectOptions}
      onChange={onChange}
      value={value}
      errored={errored}
    />
  );
};
